// @ts-check

import {SELFSTORAGE_POINT_TYPE} from "../../enums/SelfStoragePointType";

const SOURCE_ID = 'deal-list-pins-source';
const LAYER_ID = 'deal-list-pins-layer';

class DealListPinsData {
    constructor(mapInstance, mapConfig, layers, sources) {
        this._mapInstance = mapInstance;
        this._mapConfig = mapConfig;
        this._dragonflyLayers = layers;
        this._dragonflySources = sources;
        this._visible = false;
        this._deals = [];
        this._source = undefined;
        this._layer = undefined;
    }

    get sourceId() {
        return SOURCE_ID;
    }

    get layerId() {
        return LAYER_ID;
    }

    get source() {
        return this._source;
    }

    get layer() {
        return this._layer;
    }

    get visible() {
        return this._visible;
    }

    update = (deals, visible) => {
        this._visible = !!visible;
        this._deals = Array.isArray(deals) ? deals : [];

        this._removeFromStyle();

        if (!this._visible) {
            this._source = undefined;
            this._layer = undefined;
            return;
        }

        const features = this._buildFeatures(this._deals);
        if (!features.length) {
            return;
        }

        this._source = {
            id: SOURCE_ID,
            source: {
                type: 'geojson',
                data: {
                    type: 'FeatureCollection',
                    features,
                },
            },
        };

        this._layer = {
            id: LAYER_ID,
            type: 'symbol',
            source: SOURCE_ID,
            minzoom: 0,
            maxzoom: 20,
            metadata: {
                socialexplorer: {},
                isDescriptionLayer: true,
                isDealListLayer: true,
            },
            filter: ['==', '$type', 'Point'],
            layout: {
                'icon-image': [
                    'match',
                    ['get', 'pointType'],
                    SELFSTORAGE_POINT_TYPE.SS_FACILITY,
                    'deal_warehouse',
                    SELFSTORAGE_POINT_TYPE.SS_CONSTRUCTION,
                    'deal_development',
                    'deal_place', // default
                ],
                'icon-offset': [0, 0],
                'icon-anchor': 'bottom',
                'icon-allow-overlap': true,
            },
        };

        this._dragonflyLayers.push(this._layer);
        this._dragonflySources[SOURCE_ID] = this._source.source;
    };

    clear = () => {
        this._visible = false;
        this._deals = [];
        this._removeFromStyle();
        this._source = undefined;
        this._layer = undefined;
    };

    _removeFromStyle = () => {
        const layerIndex = this._dragonflyLayers.findIndex(layer => layer.id === LAYER_ID);
        if (layerIndex > -1) {
            this._dragonflyLayers.splice(layerIndex, 1);
        }
        if (this._dragonflySources[SOURCE_ID]) {
            delete this._dragonflySources[SOURCE_ID];
        }
    };

    _buildFeatures = deals =>
        deals
            .filter(deal => deal && deal.point && this._isValidPoint(deal.point))
            .map(deal => ({
                type: 'Feature',
                geometry: {
                    type: 'Point',
                    coordinates: [Number(deal.point.lng), Number(deal.point.lat)],
                },
                properties: {
                    id: deal.id,
                    title: deal.title,
                    listId: deal.listId,
                    pointType: deal.pointType,
                    facilityId: deal.facilityId,
                    selection: deal.selection,
                    profile: deal.profile,
                    polygon: deal.polygon,
                    originalLng: deal.point.lng,
                    originalLat: deal.point.lat,
                },
            }));

    _isValidPoint = point =>
        point && Number.isFinite(Number(point.lng)) && Number.isFinite(Number(point.lat));
}

export default DealListPinsData;
